import { CheckboxGroupsItemChangeModelLazy } from '../../../models/CheckboxGroupsItemChangeModel';
export function prepareSingleCheckboxGroupsItemChangeModel(checkboxGroupItemChangeModel) {
  var calcAllItems = function calcAllItems() {
    return checkboxGroupItemChangeModel.checkboxGroupChangeModel.groupItems;
  };

  return new CheckboxGroupsItemChangeModelLazy(checkboxGroupItemChangeModel, calcAllItems);
}